import { render } from "./CallButtonPanel.vue?vue&type=template&id=1a3013f2&scoped=true&ts=true&lang=pug"
import script from "./CallButtonPanel.vue?vue&type=script&lang=ts"
export * from "./CallButtonPanel.vue?vue&type=script&lang=ts"

import "./CallButtonPanel.vue?vue&type=style&index=0&id=1a3013f2&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3013f2"]])

export default __exports__